module.exports = __webpack_public_path__ + "img/back-draft.c29adfd1.svg";